import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;

export const AlertContainer = styled.div`
	display: flex;
	gap: 15px;
	justify-content: flex-start;
	padding-bottom: 20px;

	& svg {
		margin-top: 3px;
	}
`;

export const TableContainer = styled.table`
	color: ${tokens.color_gray_dark};
	font-size: 14px;
	font-weight: 500;

	tr > td {
		padding-bottom: 10px;
	}

	& th {
		background-color: ${tokens.color_gray_light};
		padding: 10px;
		text-align: left;
		color: ${tokens.color_primary};
		font-size: 14px;
	}

	& td {
		font-size: 14px;
	}

	& img {
		align-items: center;
		width: 30px;
		height: 30px;
	}
`;

export const ImgContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;

	padding-left: 7px;
`;

export const TdName = styled.td`
	width: 33vw;
	p {
		max-width: 33vw;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;

export const TdType = styled.td`
	width: 20vw;
	li {
		padding-left: 10px;
		max-width: 20vw;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		list-style: none;
		display: flex;
		align-content: center;
		::before {
			content: '●';
			font-size: 8px;
			padding-right: 5px;
			align-self: center;
		}
	}
`;

export const TdFrequency = styled.td`
	width: 10vw;
	li {
		padding-left: 10px;
		max-width: 10vw;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		list-style: none;
		display: flex;
		align-content: center;
		::before {
			content: '●';
			font-size: 8px;
			padding-right: 5px;
			align-self: center;
		}
	}
`;
